/* eslint-disable react-hooks/exhaustive-deps */

import { useRouter } from 'next/router';
import { useUserInfoV2 } from '@monorepo-hol/providers';
import { useQuery } from 'react-query';

import { SubmenuType } from '../../components/types';

import { generateSubmenu } from './utils';

import { type GetDocumentDetailData } from './services/document-detail';
import { type GetHistoryData } from './services/history';
import DocumentLayout from './models/document';
import ConsolidationLayout from './models/consolidation';
import TranslationLayout from './models/translation';
import type { AppendiceType } from './types';
import AppendicesLayout from './models/appendices';
import type { MainCatalog } from '../../types/catalog';

export interface DetailPageLayoutProps {
  type?: 'document' | 'consolidation' | 'translation' | 'appendices';
  appendicesType?: AppendiceType;
  catalogData: MainCatalog;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  documentList: any[];
  is404: boolean;
}

export function DetailPageLayout(props: DetailPageLayoutProps) {
  const {
    type = 'document',
    appendicesType = 'main',
    catalogData,
    documentList,
    is404,
  } = props;
  const { user } = useUserInfoV2();

  const { data: dataDocument } = useQuery<GetDocumentDetailData>([
    'getDocumentDetail',
  ]);
  const data = dataDocument?.data?.data;
  const { data: dataHistory } = useQuery<GetHistoryData>(['getHistory']);

  const subMenu: SubmenuType = generateSubmenu(data, dataHistory);

  const router = useRouter();
  const guid = typeof router.query?.guid === 'string' ? router.query.guid : '';
  const docId =
    typeof router.query?.docId === 'string' ? router.query.docId : undefined;

  const commonProps = {
    data,
    dataDocument,
    guid,
    subMenu,
    user,
    docId,
    is404,
  };

  if (type === 'document') {
    return (
      <DocumentLayout
        {...commonProps}
        catalogData={catalogData}
        appendicesList={documentList}
      />
    );
  }

  if (type === 'consolidation') {
    return (
      <ConsolidationLayout
        {...commonProps}
        catalogData={catalogData}
        appendicesList={documentList}
      />
    );
  }

  if (type === 'translation') {
    return (
      <TranslationLayout
        {...commonProps}
        catalogData={catalogData}
        appendicesList={documentList}
      />
    );
  }

  if (type === 'appendices') {
    return (
      <AppendicesLayout
        {...commonProps}
        type={appendicesType}
        catalogData={catalogData}
        documentList={documentList}
      />
    );
  }

  return null;
}

export default DetailPageLayout;
